import React, { useEffect, useState, useCallback } from 'react';
import Icon from './nav/Icon';

const BottomSheet = ({ isOpen, onClose, children, title }) => {
  const [animate, setAnimate] = useState(false);

  const close = useCallback(() => {
    setAnimate(false);
    setTimeout(onClose, 300);
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => setAnimate(true));
      const onKey = (e) => { if (e.key === 'Escape') close(); };
      document.addEventListener('keydown', onKey);
      return () => document.removeEventListener('keydown', onKey);
    }
    setAnimate(false);
    const timer = setTimeout(() => { document.body.style.overflow = ''; }, 300);
    return () => clearTimeout(timer);
  }, [isOpen, close]);

  if (!isOpen && !animate) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center transition-all duration-300 ${isOpen ? 'visible' : 'invisible'}`}>
      <div
        className={`absolute inset-0 bg-black/50 transition-opacity duration-300 ${animate ? 'opacity-100' : 'opacity-0'}`}
        onClick={close}
        aria-hidden="true"
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className={`relative w-full max-w-lg bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl transform transition-transform duration-300 ease-out max-h-[90dvh] flex flex-col ${animate ? 'translate-y-0 scale-100' : 'translate-y-full sm:translate-y-10 sm:scale-95'}`}
      >
        <div className="flex justify-center pt-2.5 pb-1 sm:hidden shrink-0" onClick={close}>
          <div className="w-10 h-1.5 bg-slate-300 rounded-full" />
        </div>
        <div className="flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4 border-b border-slate-100 shrink-0">
          <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
          <button type="button" onClick={close} aria-label="Close"
            className="w-9 h-9 flex items-center justify-center bg-slate-100 rounded-full hover:bg-slate-200 transition-colors">
            <Icon name="close" className="w-5 h-5 text-slate-500" />
          </button>
        </div>
        <div className="px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))] sm:p-6 overflow-y-auto overscroll-contain">
          {children}
        </div>
      </div>
    </div>
  );
};

export default BottomSheet;
